import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { type MaybeRefOrGetter, unref, computed } from 'vue';
import type { GetCountrySeoTagRequest } from '@/shared/api/experience';

export const useCountryTagSeoInfo = (tagId: MaybeRefOrGetter<string>, enabled: MaybeRefOrGetter<boolean>) => {
  const { getSeoCountryTag } = useExperienceApi();

  const queryKey = computed(() => ['countryTagSeoInfo', unref(tagId)]);

  const {
    data: countryTagSeoData,
    isSuccess,
    isFetching,
  } = useQuery({
    queryKey,
    queryFn: async () => {
      const response = await getSeoCountryTag({ query: { ids: unref(tagId) as string } });

      return response.data;
    },
    enabled: computed(() => !!unref(enabled)),
    placeholderData: (prevData): GetCountrySeoTagRequest =>
      prevData || ({ faq: {}, seo: {} } as GetCountrySeoTagRequest),
    staleTime: 0,
    refetchOnMount: 'always',
  });

  return {
    countryTagSeoData,
    isSuccess,
    isFetching,
  };
};
